// ABAS_ANTIGAS_WHATS_0311 (GROK2): esconde Sistema de Recuperação, Gatilhos e Chatbot (menus, rotas e catálogo de abas extras).
// Switch: arquivo private/ABAS_ANTIGAS_WHATS_OFF PRESENTE = abas escondidas; AUSENTE = abas voltam (lido via /api/evo-unica/flag).
// Sem resposta da API, usa o último valor salvo no navegador (padrão: escondidas).
import React from 'react';
import { Navigate } from 'react-router-dom';
import { API_BASE_URL } from '../apiBase';

const LS = 'aurax_abas_antigas_off_0311';
export const ABAS_ANTIGAS_PATHS = ['/recuperacao', '/mass-dispatch', '/triggers', '/triggers/chatbot'];
export const ABAS_ANTIGAS_MODS = ['recuperacao', 'disparo', 'gatilhos', 'chatbot'];
export function abasAntigasOff() {
  try { const v = window.localStorage.getItem(LS); return v === null ? true : v === '1'; } catch (_) { return true; }
}
function apply(off) { try { document.body.classList.toggle('aurax-abas-antigas-off', !!off); } catch (_) { /* noop */ } }
apply(abasAntigasOff());
try {
  fetch(`${API_BASE_URL}/api/evo-unica/flag`, { credentials: 'include', cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      if (!d || typeof d.abas_antigas_whats_off !== 'boolean') return;
      const antes = abasAntigasOff();
      try { window.localStorage.setItem(LS, d.abas_antigas_whats_off ? '1' : '0'); } catch (_) { /* noop */ }
      apply(d.abas_antigas_whats_off);
      if (antes !== d.abas_antigas_whats_off) window.dispatchEvent(new Event('aurax-abas-antigas-0311'));
    })
    .catch(() => {});
} catch (_) { /* noop */ }

export function AbasAntigasGuard({ children }) {
  if (abasAntigasOff()) return <Navigate to="/dashboard" replace />;
  return children;
}
